import axios from './axios'

const EndPoints = {
  Token: '/v1/auth/application_token',
  Offers: '/v1/Search/FilterOffers',
  Unitys: '/v1/Search/Filter',
  Verify: 'v1/auth/Token_Verify',
  Unity: 'v1/Unity',
  Categories: '/v1/Category/All',
  Location: '/v1/Address/Search/',
  Evaluate: '/v1/ToEvaluate',
  Complain: 'v2/Complain',
  ReportComplain: 'v2/ReportComplain'
}

const COMUNIDADE_IUPP_PORTAL_API = {
  URL: process.env.REACT_APP_COMUNIDADE_IUPP_API
}
export const ComunidadeIuppService = {
  async getAccessToken () {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).get(`${EndPoints.Token}`)
  },
  async getOffers (payload) {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).post(`${EndPoints.Offers}`, payload)
  },
  async getUnitys (payload) {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).post(`${EndPoints.Unitys}`, payload)
  },
  async getLocation (cep) {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).get(`${EndPoints.Location}${cep}`)
  },
  async getCategories () {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).get(`${EndPoints.Categories}`)
  },
  async tokenVerify () {
    axios(COMUNIDADE_IUPP_PORTAL_API.URL).get(`${EndPoints.Token}`)
      .then(response => {
        if (window.localStorage.getItem('comunidadeIuppToken')) {
          window.localStorage.removeItem('comunidadeIuppToken')
        }
        if (response.data.objectReturn.token) {
          window.localStorage.setItem('comunidadeIuppToken', response.data.objectReturn.token)
        }
      })
      .catch(() => {})
  },
  async getUnity (rede, unidade) {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).get(`${EndPoints.Unity}/` + unidade + `/` + rede)
  },
  async getEvaluate (companyId, items = 5, page = 0) {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).get(`${EndPoints.Evaluate}/All/${companyId}/${items}/${page}`)
  },
  async createEvaluate (payload) {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).post(`${EndPoints.Evaluate}/Create`, payload)
  },
  async getComplain () {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).get(`${EndPoints.Complain}/all`)
  },
  async createReportComplain (payload) {
    return axios(COMUNIDADE_IUPP_PORTAL_API.URL).post(`${EndPoints.ReportComplain}/Create`, payload)
  },
  async refreshToken () {
    const resultToken = await this.getApplicationToken()
    if (window.localStorage.getItem('comunidadeIuppToken')) {
      window.localStorage.removeItem('comunidadeIuppToken')
    }
    if (resultToken.data.objectReturn.token) {
      window.localStorage.setItem('comunidadeIuppToken', resultToken.data.objectReturn.token)
    }
  }

}



// WEBPACK FOOTER //
// ./src/features/Services/ComunidadeIupp/ComunidadeIuup.js